import React from 'react';
import bem from 'utils/bem';
import { Link } from 'react-router-dom';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import Icon from 'components/Icon';
import WhiteBox from 'components/WhiteBox';
import Model from '../../../../model';
import './index.sass';

const { block, el } = bem('front-consultations');

const Consultations = () => {
    const { modal } = Model;
    const { isKZ } = Model.kz;

    return (
        <div className={ block() }>
            <WhiteBox>
                <div className={ el('top-block') }>
                    <div className={ el('title') }><Text serif>Консультации</Text></div>
                    <div className={ el('types') }>
                        <div className={ el('type') }>
                            <Icon name={ 'headset' } />
                            <Text>Онлайн-встреча</Text>
                        </div>
                        <div className={ el('type') }>
                            <Icon name={ 'handshake' } />
                            <Text>Очная встреча</Text>
                        </div>
                    </div>
                    <div className={ el('description-block') }>
                        <div className={ el('description') }>
                            <Text>
                                Специалисты «Ответа» проводят консультации лично в Москве и Санкт-Петербурге и онлайн.
                                Работа с психотерапевтом в дистанционном формате так же эффективна, как личная встреча,
                                потому что близость, которая важна для подлинного контакта, измеряется не в километрах.
                                Продолжительность консультации от 45 до 60 минут в зависимости от метода, в котором
                                работает терапевт.
                            </Text>
                        </div>
                        <div className={ el('details') }>
                            <Text>Подробнее можете все узнать в разделах <Link to={ '/faq' }>«Вопрос — Ответ»</Link> и <Link
                                to={ '/payment_rules' }>«Правила сервиса»</Link></Text>
                        </div>
                    </div>
                </div>
                <div className={ el('buttons') }>
                    { !isKZ && <IconButton name={ 'gift' } to={ '/certificates' } mod={ 'transparent-gold' }><Text>Купить
                        подарочный
                        сертификат</Text></IconButton> }
                    <IconButton name={ 'calendar-blank' } onClick={ modal.openOrderForm } mod={ 'gold' }><Text>Записаться
                        на
                        консультацию</Text></IconButton>
                </div>
            </WhiteBox>
        </div>
    );
}

export default Consultations;
